import uuid from 'uuid';

export const uid = () => {
    return uuid('MDM', 'RIO');
};

export default uid;
